// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedProduct: null
}

const products = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }
    case 'GET_PRODUCTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'ADD_PRODUCT':
      return { ...state }
    case 'DELETE_PRODUCT':
      return { ...state }
    case 'GET_PRODUCT':
      return { ...state, selectedProduct: action.selectedProduct }
    case 'EDIT_COMPANY':
      return { ...state }
    default:
      return { ...state }
  }
}
export default products
